//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import { axiosGet } from '../../../../../axios/axios.js'
import { convertTime } from '../../../../../components/helpers.js'
import Rectangle from '../../../sections/Dashboard/StatisticClaimRoads/components/Rectangle.vue'

export default {
  components: {
    Rectangle
  },
  props: {
    statisticsItemsInput: {
      type: Array,
      default: null
    },
    calcTimeInput: {
      type: String,
      default: null
    }
  },
  data: function () {
    return {
      loading: false,
      mounted: false,
      todayEfficiency: null,
      calcTime: null,
      workAreas: [],
      defaultWorkAreas: ['trafficLight', 'transportDetector', 'TOI', 'cameraTV', 'cameraFVF']
    }
  },
  computed: {
    calcTimeStr: function () {
      return this.calcTimeInput || this.todayEfficiency && this.todayEfficiency.calcTime && convertTime(this.todayEfficiency.calcTime) || null
    },
    todayWorkAreasEfficiency: function () {
      const statisticsItems = this.statisticsItemsInput || this.todayEfficiency && this.todayEfficiency.statisticsItems
      return statisticsItems && statisticsItems
        .filter(item => this.workAreas.includes(item.type))
        .sort((a, b) => this.defaultWorkAreas.indexOf(a.type) - this.defaultWorkAreas.indexOf(b.type))
    }
  },
  watch: {
    todayEfficiency: {
      handler: function () {
        if (this.mounted && this.todayEfficiency != null) {
          this.addScreenshotClass()
        }
      },
      immediate: true,
      deep: true
    }
  },
  mounted () {
    this.mounted = true
    if (this.mounted && this.todayEfficiency != null) {
      this.addScreenshotClass()
    }
  },
  created: function () {
    if (!this.statisticsItemsInput) {
      const query = this.$route.query
      if (query && query.workAreas) {
        this.workAreas = query.workAreas
      } else {
        this.workAreas = this.defaultWorkAreas.toString()
        this.updateQuery()
      }
      this.load()
    } else {
      this.workAreas = this.defaultWorkAreas.toString()
    }
  },
  methods: {
    addScreenshotClass: function () {
      const $efficiency = document.querySelector('.efficiency')
      if ($efficiency) {
        $efficiency.classList.add('screenshot_area')
      }
    },
    getWorkAreaCountValueByKey: function (key, workArea, percent = false) {
      let result = ''
      const count = workArea[key + 'Manual'] || workArea[key]
      if (percent) {
        result = parseFloat(count).toFixed(2) + '%'
      } else {
        result = count
      }
      return result
    },
    load: function () {
      const params = new URLSearchParams()

      const date = new Date()
      date.setHours(0, 0, 0, 0)

      params.set('to', date.getTime())
      params.set('from', date.getTime() - 1)

      this.loading = true
      return axiosGet({
        url: '/vis/itsEfficiencyStatistics/onetouch?' + params.toString(),
        onSuccess: response => {
          const result = response.data.result || []
          this.todayEfficiency = result.find(res => res.date === date.getTime()) || null
        },
        onFailure: 'Ошибка получения эффективности работы ИТС по Roads'
      }).finally(() => {
        this.loading = false
      })
    },
    updateQuery: function () {
      const query = {}
      query.workAreas = this.workAreas
      this.$router.replace({ path: this.$route.path, query: query })
    }
  }
}

